import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { new_ErrorAlert } from "./ExportManager";
import { GovRow } from "./GovRow";
import { SpwkGovStep } from "./GovRowHelper";
import { HisBasic } from "./HisBasic";
import { SpwkMetaData } from "./SpwkMetaData";
import { SpwkMetaTable } from "./SpwkMetaTable";

export class GovRowParser_疲勞狀況 {// 問卷類別6 : 疲勞狀況
  //yao all
  static ConvertToHisRow(func_guid: string, func_code: string, step: SpwkGovStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): GovRow[] {

    if (step.Chapter !== SpwkUtilV3.CHAPTER_疲勞狀況) {
      throw new Error("5984985 必須是 CHAPTER_疲勞狀況 !!!");
    }

    if (func_guid === SpwkUtilV3.A01_func_guid) {
      throw new_ErrorAlert("4684143 A01 還沒有轉申報格式 !!!")
    }

    let re: GovRow[] = [];

    let q_meta_list = meta_table.FilterQuestions_ByChapter(SpwkUtilV3.CHAPTER_疲勞狀況);

    for (const q_meta of q_meta_list) {
      if (q_meta.q_gov_code == null || q_meta.q_gov_code === "") {
        continue;  // pass; 目前不處理沒有指定申報代碼的題目
      }
      const gov_row = 申報通用解碼(q_meta, 基本檔, step, meta_table);
      re.push(gov_row);
    }
    re.sort((a, b) => a.問題編號.localeCompare(b.問題編號));
    return re;
  }

}


export function 申報通用解碼(q_meta: SpwkMetaData, 基本檔: HisBasic, step: SpwkGovStep, meta_table: SpwkMetaTable): GovRow {
  const gov_row: GovRow = new GovRow(基本檔, step.Gov問卷類別);

  gov_row.問題編號 = q_meta.q_gov_code;

  /* 填寫勾選 OneHot 格式 */
  let opt_meta_list = meta_table.FilterOptions_ByQuestionGuid(q_meta.question_guid);
  let one_hot_value = ConvertToOneHotFormat(q_meta, opt_meta_list);
  gov_row.答題內容 = one_hot_value; // "010010"


  /* 填寫 TextBox */
  return gov_row;
}


// 一整題的選項會被合併為 one hot 格式 "10001001"，其中index查 o_gov_code
function ConvertToOneHotFormat(q_meta: SpwkMetaData, opt_meta_list: SpwkMetaData[]): string {
  //#region 取得最大的 index 用來新增 Array (並確保都有設定 index)
  let max_idx: number = -1;
  for (const opt_meta of opt_meta_list) {
    let code = opt_meta.o_gov_code;

    let n = parseInt(code);
    if (isNaN(n)) {
      throw new_ErrorAlert("4341686 申報選項必須有 o_gov_code 且為數字 !!!\nopt_meta.data_guid: " + opt_meta.data_guid);
    }

    if (n > max_idx) {
      max_idx = n;
    }
  }
  //#endregion

  var check_arry = new Array((max_idx + 1)).fill("0");

  if (q_meta.kind === SpwkUtilV3.Q_KIND_多選) {
    for (const opt_meta of opt_meta_list) {
      if (opt_meta.rhf_value === true) {
        let idx = parseInt(opt_meta.o_gov_code);
        check_arry[idx] = "1";
      }
    }
  } else if (q_meta.kind === SpwkUtilV3.Q_KIND_單選) {

    let rhf_value = q_meta.rhf_value ?? "";
    let find_opt = opt_meta_list.find(x => x.code === rhf_value);

    if (find_opt != null) {
      let idx = parseInt(find_opt.o_gov_code);
      check_arry[idx] = "1";
    }

  } else {
    throw new_ErrorAlert("484316 申報 通用問題 必須是 多選 或 單選 !!!\nq_meta.data_guid= " + q_meta.data_guid);

  }


  return check_arry.join("");

}


